import React, { useEffect, useState, } from 'react'
import { Link, useParams, } from 'react-router-dom'
import HtmlParser from 'react-html-parser';
import moment from 'moment';
import $ from 'jquery';
import axios from 'axios';
import Swal from 'sweetalert2';

import useAuth from '../../controllers/users/useAuth';
import Menu from '../main/Menu'

import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, numberSet, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, separatorsNumbersSet,
    awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings'
import BankAccountMovementDetails from './BankAccountMovementDetails';
import BankAccountMovementAddEditDetails from './BankAccountMovementAddEditDetails';
import { bankAccountMovementModelGet } from '../../models/bankAccounts/bankAccountMovement';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { bankModelGet } from '../../models/banks/bank';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { purchaseModelGet } from '../../models/expenses/purchase';

const currentMethod = 'BankAccountMovements';

const { collections: dbColle, colors, icons, messages, labels, } = globalSettings;
const { html, tempusDominus, } = globalSettings?.react;
const { backend, reports, } = globalSettings?.app;

const neutralValue = 0.00;

export default function BankAccountMovements({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    let swalProperties = {};
    const { id, } = useParams();
    //const history = useHistory();
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const dtBankAccountMovementsId = 'dtBankAccountMovements';
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ building: true, bankAccount: true, movements: true, });
    //const [showData, setShowData] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [btnAddIsDisbled, setBtnAddIsDisabled] = useState(true);
    const descriptionPercentageObj = {
        success: 'description-percentage text-success',
        primary: 'description-percentage text-primary',
        danger: 'description-percentage text-danger',
    };
    //#endregion variables

    //#region bank
    const [bank, setBank] = useState(bankModelGet({}));
    //#endregion bank

    //#region Collecntion Bank account
    const [bankAccount, setBankAccount] = useState(bankAccountModelGet({}));
    const [movementData] = useState({
        id: '',
        buildingId: '',
        limit: 0,
        ordersBy: [],
        conditionals: [],
        dateFrom: '',
        dateTo: '',
        movementsGet: false,
        type: '',
    });
    const movementsFromId = 'movementsFrom';
    const movementsToId = 'movementsTo';
    const [movementFromError, setMovementFromError] = useState('');
    const [movementToError, setMovementToError] = useState('');

    const [previousBalance, setPreviousBalance] = useState(neutralValue);
    const [incomeAmount, setIncomeAmount] = useState(neutralValue);
    const [expensesAmount, setExpensesAmount] = useState(neutralValue);
    const [movementAmount, setMovementAmount] = useState(neutralValue);
    //#endregion bank account

    //#region building
    let buildingTwo = {};
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region movements
    const [movements, setMovements] = useState({});
    const [bankAccountMovementShowModal, setBankAccountMovementShowModal] = useState(false);
    const [bankAccountMovement, setBankAccountMovement] = useState(bankAccountMovementModelGet({}));
    const [bankAccountMovementDetailShowModal, setBankAccountMovementDetailShowModal] = useState(false);
    //#endregion movements

    //#region others
    const controls = {
        buttons: {
            add: {
                id: 'btnAdd',
                className: 'btn btn-outline-success',
            },
            search: {
                id: 'btnSearch',
                className: 'btn btn-outline-info mx-1',
            },
            print: {
                id: 'btnPrint',
                className: 'btn btn-outline-secondary',
            },
            back: {
                id: 'btnBack',
                className: 'btn btn-outline-success mx-1',
            },
        },
        dataTables: {
            movements: {
                buttons: {
                    process: {
                        className: 'btn btn-outline-primary float-right btn-sm',
                        id: 'btnDtMovementsProcess',
                    },
                },
                icons: {
                    process: {
                        id: 'icobtnDtMovementsProcess',
                        className: icons?.fasFa?.cogs,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtBankAccountMovementsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtBankAccountMovementsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    process: {
                        id: 'spDtMovementsProcess',
                        className: '',
                    },
                },
            },
        },
        icons: {
            add: {
                id: 'icoAdd',
                className: icons?.plusCircle,
            },
            search: {
                id: 'icoSearch',
                className: icons?.search,
            },
            print: {
                id: 'icoPrint',
                className: icons?.print,
            },
            back: {
                id: 'icoBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            bank: {
                id: 'inputBank',
                className: 'form-control bg-transparent text-black',
            },
            bankAccountNumber: {
                id: 'inputBankAccountNumber',
                className: 'form-control bg-transparent text-black',
            },
            created: {
                id: 'inputCreated',
                className: 'form-control bg-transparent text-black',
            },
            type: {
                id: 'inputType',
                className: 'form-control bg-transparent text-black',
            },
            currentBalance: {
                id: 'inputCurrentBalance',
                className: 'form-control bg-transparent text-black text-right',
            },
            dateFrom: {
                id: 'inputDateFrom',
                className: 'form-control datetimepicker-input',
            },
            dateTo: {
                id: 'inputDateTo',
                className: 'form-control datetimepicker-input',
            },
        },
        radioButtons: {
            all: {
                id: 'rButonAll',
                className: 'icheck-primary d-inline',
                name: 'radioButtonName',
            },
            income: {
                id: 'rButonIncome',
                className: 'icheck-primary d-inline',
                name: 'radioButtonName',
            },
            expense: {
                id: 'rButonExpense',
                className: 'icheck-primary d-inline',
                name: 'radioButtonName',
            },
        },
        spinners: {
            add: {
                id: 'spAdd',
                className: '',
            },
            search: {
                id: 'spSearch',
                className: '',
            },
            print: {
                id: 'spPrint',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
    };
    //#endregion others

    //#region bank (methods)
    //#region old code
    // const bankGetAsync = async (bankId = '', subMethodName = '') => {
    //     let response = responseGet();
    //     try {
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };
    //         //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlBanks}/${bankId}`, headerObj);
    //         result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlBanks}/${bankId}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             //await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return response;
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: bankGetAsync<br/>`;
    //         if (!isEmpty(subMethodName)) {
    //             response.msgText += `Sub method: ${subMethodName}`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         //sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    //     return response;
    // };
    //#endregion old code
    //#endregion bank (methods)

    //#region bank account (methods)
    const bankAccountGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountGetAsync';
        let response = responseGet();
        try {
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    };
    //#endregion bank account (methods)

    //#region building (methods)
    //#region old code
    // const localBuildingGetAsync = async (buildingId = '') => {
    //     let response = responseGet();
    //     try {
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };
    //         //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlBuildings}/${buildingId}`, headerObj);
    //         result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlBuildings}/${buildingId}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return response;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localBuildingGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion building (methods)

    //#region movement (methods)
    const movementsCallAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'movementsCallAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e?.key, subMethod: currentMethod, })?.result && e?.key === 'Enter') {
                $(`#${controls?.buttons?.search?.id}`)?.trigger('click');
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankAccountMovementsGetAsync = async ({
        e = {},
        bankAccount_ = bankAccountModelGet({}),
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountMovementsGetAsync';
        const dataGetAsyncName = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                if (e?.target?.type !== 'radio') {
                    e?.preventDefault();
                }
            }
            //#endregion initialize

            if (subMethod !== dataGetAsyncName) {
                setShowLoading({ building: false, collectionCash: false, movements: true, });
            }

            //#region clear dataTables
            response = await dataTablesClearAsync({
                bankAccountMovements: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion clear dataTables

            //#region variables
            let movementsLocal = [];
            let incomeAmountLocal = neutralValue;
            let expenseAmountLocal = neutralValue;
            let movementAmountLocal = neutralValue;
            let previousBalanceLocal = neutralValue;
            let bankAccountLocal = bankAccountModelGet({});
            //#endregion variables

            //#region form data validate
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                response = await validateFormDataAsync({
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return;
                }
            }
            //#endregion form data validate

            //#region total movements set
            response = await bankAccountMovementsTotalSetAsync({
                previousBalance: neutralValue,
                income: neutralValue,
                expenses: neutralValue,
                movementAmount: neutralValue,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion total movements set

            //#region movement data set
            response = await movementDataSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion movement data set

            //#region movements get
            movementData.buildingId = bankAccount_.buildingId;

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                buildingId: movementData?.buildingId,
                bankAccountId: id,
                dateFrom: movementData?.dateFrom,
                dateTo: movementData?.dateTo,
                method: backend?.methods?.movements,
                type: movementData?.type,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            movementsLocal = response?.result?.movements || [];
            previousBalanceLocal = response?.result?.previousBalance || neutralValue;
            incomeAmountLocal = response?.result?.income || neutralValue;
            expenseAmountLocal = response?.result?.expense || neutralValue;
            movementAmountLocal = response?.result?.movementAmount || neutralValue;
            bankAccountLocal = response?.result?.bankAccount || {};

            if (subMethod !== dataGetAsyncName) {
                setBankAccount(bankAccountLocal)
            }

            setMovements({});
            setMovements({
                ...movementData,
                movements: movementsLocal,
                previousBalance: previousBalanceLocal,
                income: incomeAmountLocal,
                expense: expenseAmountLocal,
                movementAmount: movementAmountLocal,
                bankAccount,
                building,
            });
            //#endregion movements get

            //#region dataTables set
            //#region old code
            // response = dataTableSetAsync(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setBtnDisabled(true);
            //     setShowLoading(false);
            //     
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }
            //#endregion old code
            //#endregion dataTables set

            //#region dataTable data load
            response = await dataTableBankAccountMovementsLoadDataAsync({
                movements: movementsLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion dataTable data load

            //#region movementTotals set
            response = await bankAccountMovementsTotalSetAsync({
                previousBalance: previousBalanceLocal,
                income: incomeAmountLocal,
                expenses: expenseAmountLocal,
                movementAmount: movementAmountLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion movementTotasl set

            //#region bank get account
            //#region old code
            // if (!isUndefined(e) && !isNull(e)) {
            //     response = await bankAccountGetAsync('bankAccountMovementsGetAsync');
            //     if (!response?.isSuccess || response?.isWarning) {
            //         setBtnDisabled(true);
            //         setShowLoading(false);
            //         
            //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //         return;
            //     }
            //     setBankAccount(response.result);
            // }
            //#endregion old code
            //#endregion bank get account

            setBtnDisabled(false);

            if (subMethod !== 'dataGetAsync') {
                setShowLoading({ building: false, collectionCash: false, movements: false, });
            }
        } catch (ex) {
            setBtnDisabled(true);
            setShowLoading({ building: false, bankAccount: false, movements: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const movementDataSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'movementDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.from = $(`#${movementsFromId}`)?.datetimepicker('date')?._d;
            //let dateTimeObj?.to = $(`#${movementsToId}`)?.datetimepicker('date')?._d;
            //#endregion old code
            let dateTimeObj = {
                date: tempusDominus?.format?.date?.ymdTwo,
                time: 0,
                from: $(`#${movementsFromId}`)?.datetimepicker('date')?._d,
                to: $(`#${movementsToId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            dateTimeObj.from = dateTimeFormatGlobalSet({
                date: dateTimeObj?.from,
                type: dateTimeObj?.date,
                format: dateTimeObj?.time,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            }).result;
            dateTimeObj.to = dateTimeFormatGlobalSet({
                date: dateTimeObj?.to,
                type: dateTimeObj?.date,
                format: dateTimeObj?.time,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            }).result;

            movementData.id = id;
            movementData.dateFrom = dateTimeObj?.from;
            movementData.dateTo = dateTimeObj?.to;
            movementData.movementsGet = true;

            response = await radioButtonsStatusCheckedGetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            movementData.type = response.result;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const bankAccountMovementsPrintAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountMovementsPrintAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region variables
            let reportPrint = {
                id: '',
            };
            //#endregion variables

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region bankAccountMovements create
            movements.bankAccountId = id;
            movements.user = auth?.user || {};
            movements.method = dbColle?.bankAccountMovements;

            dataObj = Object?.assign({
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReports}/`,
                bank: bank,
            },
                movements
            );
            delete dataObj.id;
            delete dataObj.customId;
            delete dataObj.processType;

            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };
            
            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            reportPrint = response?.result || {};

            window?.open(`/${reports?.bankAccountMovementsPrint}/${reportPrint?.id}`, '_blank');
            //#endregion bankAccountMovements create

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankAccountMovementAddEditDeleteAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountMovementAddEditDeleteAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region variables
            let showModalLocal = true;
            //let bankLocal = bankModelGet({});
            //let bankAccountLocal = bankAccountModelGet({});
            let bankAccountMovementLocal = bankAccountMovementModelGet({});
            //#endregion variables

            if (processType === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, bankAccount: false, movements: true, });
            }

            //#region bankAccountMovement get
            setProcessType(processType);

            //#region headerObj set
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
            };
            //#endregion headerObj set

            switch (processType) {
                case -1:
                    showModalLocal = false;

                    //#region bankAccountMovement get
                    headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccountMovements}/${id}`;

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, bankAccount: false, movements: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    //bankLocal = response?.result?.bank || {};
                    //bankAccountLocal = response?.result?.bankAccount || {};
                    bankAccountMovementLocal = response?.result?.bankAccountMovement || {};

                    setShowLoading({ building: false, bankAccount: false, movements: false, });
                    //#endregion bankAccountMovement get

                    //#region show message
                    dataObj = {
                        type: bankAccountMovementLocal.type === 'E' ?
                            labels?.egress?.[languageObj?.id] :
                            labels?.income?.[languageObj?.id],
                        date: dateTimeFormatGlobalSet({
                            date: bankAccountMovementLocal?.date,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            secondsShow: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        reference: bankAccountMovementLocal?.reference,
                        amount: separatorsNumbersSet({
                            number: bankAccountMovementLocal?.amount * (bankAccountMovementLocal?.type === 'E' ? -1 : 1),
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    };

                    let msgTextObj = {
                        //one: `${labels?.bank?.[languageObj?.id]}: <b>${bankLocal?.description}</b><br/>`,
                        //two: `${labels?.account?.[languageObj?.id]}: <b>${bankAccountLocal?.number}</b><br/>`,
                        one: `${labels?.type?.[languageObj?.id]}: <b>${dataObj?.type}</b><br/>`,
                        two: `${labels?.date?.[languageObj?.id]}: <b>${dataObj?.date}</b><br/>`,
                        three: `${labels?.amount?.[languageObj?.id]}: <b>${dataObj?.amount}</b><br/>`,
                        four: `${labels?.reference?.[languageObj?.id]}: <b>${dataObj?.reference}</b><br/>`,
                        five: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };

                    swalProperties = {
                        icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                        title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                        html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}${msgTextObj?.four}${msgTextObj?.five}`,
                        timer: null,
                        backdrop: true,
                        confirmButtonColor: globalSettings?.colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: true, //!Swal.isLoading(), //true,
                        cancelButtonColor: globalSettings?.colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        preConfirm: async () => {
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal?.update({
                                    icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                    title: `${messages?.processing?.[languageObj?.id]}...`,
                                    html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}${msgTextObj?.four}`,
                                    showConfirmButton: false,
                                });

                                //#region bankAccountMovement delete
                                headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccountMovements}/${id}`;

                                result = await axios?.delete(
                                    headerObj?.url,
                                    headerObj,
                                );

                                response = result?.data || {};

                                if (!response?.isSuccess || response?.isWarning) {
                                    await sendMessageCloseCurrentWindowAsync({
                                        msgType: response?.msgType,
                                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                        closeWindow: false,
                                        urlGoTo: response?.urlGoTo,
                                        auth: auth,
                                        isLogout: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    });
                                    return;
                                }
                                //#endregion bankAccountMovement delete

                                $(`#${controls?.buttons?.search?.id}`)?.trigger('click');

                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: 0,
                                    msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                            } catch (ex) {
                                //#region Error
                                response.isSuccess = false;
                                response.msgType = -1;
                                response.msgText = `Method: ${currentMethod}<br/>`;
                                response.msgText += `Error: ${ex?.message}`;
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                });
                                //#endregion Error
                            }
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                    };

                    await Swal.fire(swalProperties);
                    //#endregion show message
                    return;
                case 0:
                    setBankAccountMovement(
                        bankAccountMovementModelGet({
                            buildingId: !isUndNullEmp({ data: building?.id, subMethod: currentMethod, })?.result ?
                                building?.id :
                                buildingTwo?.id,
                            bankId: bank?.id,
                            bankAccountId: bankAccount?.id,
                            type: '',
                            subType: '',
                            userId: auth?.user?.uid,
                        })
                    );
                    break;
                case 1:
                    headerObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccountMovements}/${id}`;

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, bankAccount: false, movements: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    setBankAccountMovement(response?.result?.bankAccountMovement || {});
                    showModalLocal = true;
                    break;
                default:
                    break;
            }
            //#endregion bankAccountMovement get

            //#region bankAccountMovement get
            //#region old code
            // if (processType >= 1 && processType <= 2) {
            //     headerObj = {
            //         headers: {
            //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //             languageId: languageObj?.id,
            //         },
            //         url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccountMovements}/${id}`,
            //     };

            //     result = await axios?.get(
            //         headerObj?.url,
            //         headerObj,
            //     );

            //     response = result?.data || {};

            //     if (!response?.isSuccess || response?.isWarning) {
            //         setShowLoading({ building: false, bankAccount: false, movements: false, });
            //         await sendMessageCloseCurrentWindowAsync({
            //             msgType: response?.msgType,
            //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //             closeWindow: false,
            //             urlGoTo: response?.urlGoTo,
            //             auth: auth,
            //             isLogout: false,
            //             languageId: languageObj?.id,
            //             subMethod: currentMethod,
            //         });
            //         return;
            //     }

            //     setBankAccountMovement(response?.result?.bankAccountMovement || {});
            //     showModalLocal = true;
            // }
            //#endregion old code
            //#endregion bankAccountMovement get

            if (processType === 0) {
                await awaitDelay({ delayTimer: globalSettings?.timers?.threeNanoSeconds, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, bankAccount: false, movements: false, });
            }

            //#region old code
            // if (processType === 2) {
            //     setBankAccountMovementDetailShowModal(showModalLocal);
            // } else {
            //     setBankAccountMovementShowModal(showModalLocal);
            // }
            //#endregion old code

            setBankAccountMovementShowModal(showModalLocal);
        } catch (ex) {
            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, bankAccount: false, movements: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankAccountMovementDetailsAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountMovementDetailsAsync';
        let response = responseGet();
        try {
            //#region variables
            let bankAccountMovementLocal = bankAccountMovementModelGet({});
            //#endregion variables

            setShowLoading({ building: false, bankAccount: false, movements: true, });

            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                buildingId: building?.id || buildingTwo?.id,
                limit: 0,
                ordersBy: [],
                conditionals: [],
                detailsGet: true,
                languageId: languageObj?.id,
            };

            if (description === dbColle?.apartmentReceiptPayments) {
                dataObj.apartmentReceiptPaymentId = id;
                dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPayments}/`;

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );
            } else if (description === dbColle?.purchasePayments) {
                dataObj.purchasePaymentId = id;
                dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlPurchasePayments}/`;

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );
            } else if (description === dbColle?.bankAccountMovements) {
                dataObj.bankAccountMovementId = id;
                dataObj.url = `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccountMovements}/`;

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );
            }

            response = result.data;
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bankAccountMovementLocal = response.result;

            //#endregion data get

            //#region data set
            setBankAccountMovement(bankAccountMovementLocal);
            //#endregion data set

            setShowLoading({ building: false, bankAccount: false, movements: false, });
            setBankAccountMovementDetailShowModal(true);
        } catch (ex) {
            setShowLoading({ building: false, bankAccount: false, movements: true, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion movement (methods)

    //#region others (methods)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let isEditLocal = false;
            let isDeleteLocal = false;
            let bankLocal = bankModelGet({});
            let buildingLocal = buildingModelGet({});
            let buildingsLocal = [buildingModelGet({})];
            let bankAccountLocal = bankAccountModelGet({});
            //#endregion variables

            setShowLoading({ building: true, bankAccount: true, movements: true, });

            //#region dataTables set
            response = await dataTableSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion dataTables set

            //#region set status checked
            response = await radioButtonsStatusCheckedAsync({
                all: true,
                income: false,
                expenses: false,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion set status checked

            //#region dateTime in control sets
            response = await dateInControlSetAsync({
                movementFrom: {},
                movementTo: {},
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion dateTime in control sets

            //#region data get
            //#region data get (bank acount)
            response = await bankAccountGetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bankLocal = response?.result?.bank || {};
            bankAccountLocal = response?.result?.bankAccount || {};
            setBank(bankLocal);
            setBankAccount(bankAccountLocal);
            //#endregion data get (bank account)

            //#region data get (building)
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlBankAccounts,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            buildingsLocal = response?.result?.buildings || [];

            if (!isUndNullEmp({ data: buildingsLocal, subMethod: currentMethod, })?.result && buildingsLocal?.length > 0) {
                buildingLocal = buildingsLocal?.find(({ id, }) => id === bankAccountLocal?.buildingId) || {};
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    setBuilding(buildingLocal);
                    buildingTwo = buildingLocal
                    //#region set enabled btn add
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result;
                    isDeleteLocal = isEditLocal;
                    setBtnAddIsDisabled(!(isEditLocal && isDeleteLocal));
                    //#endregion set enabled btn add
                } else {
                    setBtnDisabled(true);
                    setShowLoading({ building: false, bankAccount: false, movements: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            } else {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data get (building)

            //#region bank get
            //#region old code
            // response = await bankGetAsync(bankAccountLocal.bankId, 'dataGetAsync');
            // if (!response?.isSuccess || response?.isWarning) {
            //     setBtnDisabled(true);
            //     setShowLoading(false);
            //     
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }
            // setBank(response.result);
            //#endregion old code
            //#endregion bank get

            //#region movements get
            response = await bankAccountMovementsGetAsync({
                e: undefined,
                bankAccount_: bankAccountLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setBtnDisabled(true);
                setShowLoading({ building: false, bankAccount: false, movements: false, });
                return;
            }
            //#endregion movements get
            //#endregion data get

            setShowLoading({ building: false, bankAccount: false, movements: false, });
        } catch (ex) {
            setBtnDisabled(true);
            setShowLoading({ building: false, bankAccount: false, movements: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const validateFormDataAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'validateFormDataAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.from = $(`#${controls?.inputs?.dateFrom?.id}`)?.val();
            //const dateTimeObj?.to = $(`#${controls?.inputs?.dateTo?.id}`)?.val();
            //#endregion old code
            const dateTimeObj = {
                from: $(`#${controls?.inputs?.dateFrom?.id}`)?.val(),
                to: $(`#${controls?.inputs?.dateTo?.id}`)?.val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: dateTimeObj?.from, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: movementData?.dateFrom, subMethod: currentMethod, })?.result) {
                setMovementFromError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.to, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: movementData?.dateTo, subMethod: currentMethod, })?.result) {
                setMovementToError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSetAsync = async ({
        movementFrom = undefined,
        movementTo = undefined,
        subMethod = '',
    }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.from = '';
            //let dateTimeObj?.to = '';
            //const dateTimeObj?.format = tempusDominus?.format?.date?.DDMMYYYY;
            //const dateTimeObj?.formatTwo = tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.startMonth = moment().startOf('month')._d;
            //const dateTimeObj?.endMonth = moment().endOf('month')._d;
            //#endregion old code
            const dateTimeObj = {
                from: '',
                to: '',
                format: languageObj?.format?.date?.f1,
                time: 0,
                formatTwo: languageObj?.format?.date?.f11,
                startMonth: moment().startOf('month')._d,
                endMonth: moment().endOf('month')._d,
            };
            //#endregion variables

            //#region methods
            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: tempusDominus?.icons,
                buttons: tempusDominus?.buttons,
                tooltips: tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            if (!isUndNullEmp({ data: movementFrom, subMethod: currentMethod, })?.result) {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: movementFrom,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.from = dateTimeFormatGlobalSet({
                    date: dateTimeObj?.startMonth,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (!isUndNullEmp({ data: movementTo, subMethod: currentMethod, })?.result) {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: movementTo,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                dateTimeObj.to = dateTimeFormatGlobalSet({
                    date: dateTimeObj?.endMonth,
                    type: dateTimeObj?.format,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $(`#${movementsFromId}`)?.datetimepicker({
                date: moment(dateTimeObj?.from, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });

            $(`#${movementsToId}`)?.datetimepicker({
                date: moment(dateTimeObj?.to, dateTimeObj?.formatTwo),
                default: false,
                timepicker: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const goToBackAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'goToBackAsync';
        let response = responseGet();
        try {
            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            //#region methods
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            controlsStatusSet({ processType: 4, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            //history.push(backend?.urlCollectionBankAccounts);
            window.location.href = backend?.urlCollectionBankAccounts;
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            //#endregion methods
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const radioButtonsStatusCheckedAsync = async ({
        all = false,
        income = false,
        expenses = false,
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            $(`#${controls?.radioButtons?.all?.id}`)?.prop({ checked: all, });
            $(`#${controls?.radioButtons?.income?.id}`)?.prop({ checked: income, });
            $(`#${controls?.radioButtons?.expense?.id}`)?.prop({ checked: expenses, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const radioButtonsStatusCheckedGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'radioButtonsStatusCheckedGetAsync';
        let response = responseGet();
        try {
            if ($(`#${controls?.radioButtons?.all?.id}`)?.prop('checked')) {
                response.result = 'a';
            } else if ($(`#${controls?.radioButtons?.income?.id}`)?.prop('checked')) {
                response.result = 'i';
            } else if ($(`#${controls?.radioButtons?.expense?.id}`)?.prop('checked')) {
                response.result = 'e';
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTableBankAccountMovementsSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableBankAccountMovementsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtBankAccountMovementsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'orderDate', width: '0%', orderable: false, visible: false, searchable: false, },
                    { title: labels?.date?.[languageObj?.id], orderable: false, width: '10%', },
                    {
                        title: labels?.reference?.[languageObj?.id],
                        orderable: false,
                        render: function (data, type, row) {
                            return `<span style='font-size:13px;'>${data}</span>`;
                        },
                        width: '55%',
                    },
                    {
                        title: labels?.amount?.[languageObj?.id],
                        className: 'text-right',
                        orderable: false,
                        render: function (data, type, row) {
                            //#region variables
                            var colorLocal = 'black';
                            let amountLocal = undefined;
                            //#endregion variables

                            //#region methods
                            if (languageObj?.numbers?.separators?.thousands === '.') {
                                amountLocal = data?.replaceAll('.', '');
                                amountLocal = amountLocal?.replaceAll(',', '.');
                                amountLocal = numberSet({
                                    number: amountLocal,
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;
                            } else if (languageObj?.numbers?.separators?.thousands === ',') {
                                amountLocal = numberSet({
                                    number: data.replaceAll(',', ''),
                                    type: 'd',
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result;
                            }

                            if (amountLocal > 0) {
                                colorLocal = colors?.successColorExp;
                            } else {
                                colorLocal = colors?.dangerColorExp;
                            }
                            //return '<span style="color:' + color + '">' + data + '</span>';
                            return `<span style='color:${colorLocal};'>${data}</span>`;
                            //#endregion methods
                        },
                        width: '15%',
                    },
                    { title: labels?.balance?.[languageObj?.id], className: 'text-right', orderable: false, width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                ordering: true,
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                searching: false,
                //}).buttons().container().appendTo(`#${dtMovementsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTableSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableSetAsync';
        let response = responseGet();
        try {
            response = await dataTableBankAccountMovementsSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTableBankAccountMovementsLoadDataAsync = async ({
        movements = [],
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableBankAccountMovementsLoadDataAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            //#endregion variables

            //#region methods
            movements?.forEach((detail) => {
                //#region variables
                dataObj = {
                    orderDate: detail?.date,
                    date: dateTimeFormatGlobalSet({
                        date: detail?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        subMethod: currentMethod,
                    })?.result,
                    reference: dataDetailGet({
                        processType: 2,
                        movement: detail,
                        subMethod: currentMethod,
                    })?.result,
                    amount: detail?.id === detail?.bankAccountId ?
                        '' :
                        separatorsNumbersSet({
                            number: detail?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                    balance: separatorsNumbersSet({
                        number: detail?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                };
                //#endregion variables

                //#region methods
                dtRows.push([
                    dataObj?.orderDate,
                    dataObj?.date,
                    dataObj?.reference,
                    dataObj?.amount,
                    dataObj?.balance,
                    detail.type !== 0 ?
                        buttonProcessGet({
                            id: detail.id,
                            description: detail.collection,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: detail?.collection === dbColle?.bankAccountMovements &&
                                processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.edit?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: detail.collection === dbColle?.bankAccountMovements &&
                                processEvaluateGet({
                                    object: detail,
                                    property: labels?.process?.en?.toLowerCase(),
                                    process: labels?.delete?.en?.toLowerCase(),
                                    subMethod: currentMethod,
                                })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        }).result
                        :
                        '',
                ]);
                //#endregion methods
            });

            $(`#${dtBankAccountMovementsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesClearAsync = async ({
        bankAccountMovements = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesClearAsync';
        let response = responseGet();
        try {
            if (bankAccountMovements) {
                $(`#${dtBankAccountMovementsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response
    }

    const bankAccountMovementsTotalSetAsync = async ({
        previousBalance = neutralValue,
        income = neutralValue,
        expenses = neutralValue,
        movementAmount = neutralValue,
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountMovementsTotalSetAsync';
        let response = responseGet();
        try {
            setIncomeAmount(income);
            setExpensesAmount(expenses);
            setMovementAmount(movementAmount);
            setPreviousBalance(previousBalance);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region movements
            $(`#${dtBankAccountMovementsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtBankAccountMovementsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            bankAccountMovementAddEditDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            bankAccountMovementDetailsAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            bankAccountMovementAddEditDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion movements
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataDetailGet = ({
        processType = 0,
        movement = {
            id: '',
            balance: neutralValue,
            collection: '',
            collectionCashId: '',
            created: new Date(),
            date: new Date(),
            type: '',
            apartment: apartmentModelGet({}),
            apartmentReceipt: apartmentReceiptModelGet({}),
            dateTwo: new Date(),
            purchase: purchaseModelGet({}),
            reference: '',
            referenceData: '',
            subType: {
                description: '',
            }
        },
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = movement?.id;
                    break;
                case 1:
                    response.result = dateTimeFormatGlobalSet({
                        date: movement?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 2:
                    if (movement?.type !== 0) {
                        response.result = `${labels?.type?.[languageObj?.id]}: ${movement?.type === 1 ? labels?.income?.[languageObj?.id] : labels?.egress?.[languageObj?.id]}; `;
                        switch (movement?.collection) {
                            case dbColle?.apartmentReceiptPayments:
                                if (!isUndNullEmp({ data: movement?.apartment?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.apartment?.[languageObj?.id]}: ${movement?.apartment?.identifier}; `;
                                }
                                if (!isUndNullEmp({ data: movement?.apartmentReceipt?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.receipt?.[languageObj?.id]}: ${movement?.apartmentReceipt?.receiptNumberApartment}; `;
                                }
                                response.result += `${labels?.date?.[languageObj?.id]}: ${dateTimeFormatGlobalSet({
                                    date: movement?.dateTwo,
                                    type: languageObj?.format?.date?.f1,
                                    format: 0,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result}; `;
                                break;
                            case dbColle?.purchasePayments:
                                if (!isUndNullEmp({ data: movement?.purchase?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.purchase?.[languageObj?.id]}: ${movement?.purchase?.number}; `;
                                    response.result += `${labels?.number?.[languageObj?.id]}: ${movement?.purchase?.invoiceNumber}; `;
                                    response.result += `${labels?.date?.[languageObj?.id]}: ${dateTimeFormatGlobalSet({
                                        date: movement?.purchase?.date,
                                        type: languageObj?.format?.date?.f1,
                                        format: 0,
                                        addTime: false,
                                        secondsShow: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result}; `;
                                }
                                break;
                            case dbColle?.bankAccountMovements:
                                //response.result += `${replaceMessages(0, movement?.reference).result}; `;
                                response.result += `${movement?.reference}; `;
                                if (!isUndNullEmp({ data: movement?.subType, subMethod: currentMethod, })?.result) {
                                    response.result += `${movement?.subType?.description}; `;
                                }
                                response.result += `${labels?.date?.[languageObj?.id]}: ${dateTimeFormatGlobalSet({
                                    date: movement?.created,
                                    type: languageObj?.format?.date?.f1,
                                    format: 0,
                                    addTime: false,
                                    secondsShow: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result}; `;
                                break;
                            default:
                                break;
                        }

                        if (movement?.collection === dbColle?.bankAccountMovements) {
                            response.result += `${labels?.reference?.[languageObj?.id]}: ${(
                                !isUndNullEmp({ data: movement?.referenceData, subMethod: currentMethod, })?.result ?
                                    movement?.referenceData :
                                    ''
                            )}`;
                        } else {
                            //response.result += `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.reference).result}`;
                            response.result += `${labels?.reference?.[languageObj?.id]}: ${movement?.reference}`;
                        }
                    } else {
                        if (movement?.id !== movement?.collectionCashId) {
                            //response.result = `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.reference).result}`;
                            response.result = `${labels?.reference?.[languageObj?.id]}: ${movement?.reference}`;
                        } else {
                            //response.result = `${replaceMessages(0, movement?.reference).result}`;
                            response.result = `${movement?.reference}`;
                        }
                    }
                    break;
                case 3:
                    response.result = movement?.id !== movement?.collectionCashId ?
                        separatorsNumbersSet({
                            number: movement?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result :
                        '';
                    break;
                case 4:
                    response.result = separatorsNumbersSet({
                        number: movement?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.add?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.search?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.search?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.print?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.print?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.selects?.suppliers?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.dateFrom?.id}`).attr({ readOnly: (processType !== 0) });
            $(`#${controls?.inputs?.dateTo?.id}`).attr({ readOnly: (processType !== 0) });
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.movements?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.movements?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.add?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.search?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.print?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad'
        });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others (methods)

    return (
        <div>
            <Menu viewName='collection' process='collectionBankAccounts' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.movements?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={backend?.urlCollectionBankAccounts}>{labels?.bankAccounts?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.movements?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>
                                {/*buildings*/}
                                <BuildingHeader buildingsId={''}
                                    building={building}
                                    buildings={[]}
                                    btnSyncDisabled={''}
                                    methodGetAsync={null}
                                    processType={1}
                                    headerSectionValues={{}}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*bank bankAccount*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.bankAccount}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.bankAccount?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.bankAccountLogo}></img> - {labels?.bankAccount?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.bank?.id}
                                                            className={controls?.inputs?.bank?.className}
                                                            placeholder={labels?.bank?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.bank?.[languageObj?.id]}
                                                            value={bank?.description || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.university} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.bankAccountNumber?.id}
                                                            className={controls?.inputs?.bankAccountNumber?.className}
                                                            placeholder={labels?.bankAccount?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.bankAccount?.[languageObj?.id]}
                                                            value={bankAccount.number || ''} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.sortNumericUpAlt} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.created?.id}
                                                            className={controls?.inputs?.created?.className}
                                                            placeholder={labels?.created?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.created?.[languageObj?.id]}
                                                            value={dateTimeFormatGlobalSet({
                                                                date: bankAccount?.date || new Date(),
                                                                type: languageObj?.format?.date?.f1,
                                                                format: 0,
                                                                addTime: false,
                                                                secondsShow: false,
                                                                languageId: languageObj?.id,
                                                                subMethod: 'input - created',
                                                            })?.result} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.calendarAlt} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.type?.id}
                                                            className={controls?.inputs?.type?.className}
                                                            placeholder={labels?.type?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.type?.[languageObj?.id]}
                                                            value={bankAccount?.type === 'C' ?
                                                                labels?.current?.[languageObj?.id] :
                                                                labels?.savings?.[languageObj?.id]} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.piggyBank} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <input id={controls?.inputs?.currentBalance?.id}
                                                            className={controls?.inputs?.currentBalance?.className}
                                                            placeholder={labels?.currentBalance?.[languageObj?.id]}
                                                            readOnly
                                                            tooltip='tooltip'
                                                            title={labels?.currentBalance?.[languageObj?.id]}
                                                            value={separatorsNumbersSet({
                                                                number: bankAccount?.currentBalance,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'input - currentBalance'
                                                            })?.result} />
                                                        <div className='input-group-append'>
                                                            <div className='input-group-text'>
                                                                <span className={icons?.moneyBillWave} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'>
                                    </div> */}
                                </div>{/*card*/}

                                {/*movements*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.movements}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.movements?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.movementsLogo}></img> - {labels?.movements?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.create?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-3'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <div id={movementsFromId}
                                                            className='input-group date'
                                                            data-target-input='nearest'>
                                                            <input id={controls?.inputs?.dateFrom?.id}
                                                                className={controls?.inputs?.dateFrom?.className}
                                                                data-target={`#${movementsFromId}`}
                                                                data-toggle='datetimepicker'
                                                                disabled={btnDisabled}
                                                                onFocus={() => setMovementFromError('')}
                                                                onKeyDown={(e) => movementsCallAsync({ e: e, subMethod: 'input - dateFrom' })}
                                                                placeholder={labels?.from?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.from?.[languageObj?.id]}
                                                                type='text' />

                                                            <div className='input-group-append' data-target={`#${movementsFromId}`} data-toggle='datetimepicker'>
                                                                <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementFromError)}</div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group'>
                                                    <div className='input-group mb-3'>
                                                        <div id={movementsToId} className='input-group date' data-target-input='nearest'>
                                                            <input id={controls?.inputs?.dateTo?.id}
                                                                className={controls?.inputs?.dateTo?.className}
                                                                data-target={`#${movementsToId}`}
                                                                data-toggle='datetimepicker'
                                                                disabled={btnDisabled}
                                                                onFocus={() => setMovementToError('')}
                                                                onKeyDown={(e) => movementsCallAsync({ e: e, subMethod: 'input - dateTo' })}
                                                                placeholder={labels?.to?.[languageObj?.id]}
                                                                tooltip='tooltip'
                                                                title={labels?.to?.[languageObj?.id]}
                                                                type='text' />

                                                            <div className='input-group-append' data-target={`#${movementsToId}`} data-toggle='datetimepicker'>
                                                                <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(movementToError)}</div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='row text-center text-muted'>
                                                    <div className='col-md-4'>
                                                        <div className={controls?.radioButtons?.all?.className}>
                                                            <input disabled={btnDisabled}
                                                                type='radio'
                                                                id={controls?.radioButtons?.all?.id}
                                                                name={controls?.radioButtons?.all?.name}
                                                                onClick={(e) => bankAccountMovementsGetAsync({
                                                                    e: e,
                                                                    bankAccount_: bankAccount,
                                                                    subMethod: 'rButonAll - bankAccountMovementSearch',
                                                                })} />
                                                            <label htmlFor={controls?.radioButtons?.all?.id}>
                                                                {labels?.all?.[languageObj?.id]}
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className={controls?.radioButtons?.income?.className}>
                                                                <input disabled={btnDisabled}
                                                                    type='radio'
                                                                    id={controls?.radioButtons?.income?.id}
                                                                    name={controls?.radioButtons?.income?.name}
                                                                    onClick={(e) => bankAccountMovementsGetAsync({
                                                                        e: e,
                                                                        bankAccount_: bankAccount,
                                                                        subMethod: 'rButonIncome - bankAccountMovementSearch',
                                                                    })} />
                                                                <label htmlFor={controls?.radioButtons?.income?.id}>
                                                                    {labels?.income?.[languageObj?.id]}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className={controls?.radioButtons?.expense?.className}>
                                                                <input disabled={btnDisabled}
                                                                    type='radio'
                                                                    id={controls?.radioButtons?.expense?.id}
                                                                    name={controls?.radioButtons?.expense?.name}
                                                                    onClick={(e) => bankAccountMovementsGetAsync({
                                                                        e: e,
                                                                        bankAccount_: bankAccount,
                                                                        subMethod: 'rButonExpense - bankAccountMovementSearch',
                                                                    })} />
                                                                <label htmlFor={controls?.radioButtons?.expense?.id}>
                                                                    {labels?.egress?.[languageObj?.id]}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-3'>
                                                <div className='form-group text-right'>
                                                    <button id={controls?.buttons?.add?.id}
                                                        className={controls?.buttons?.add?.className}
                                                        disabled={btnDisabled || btnAddIsDisbled}
                                                        onClick={(e) => bankAccountMovementAddEditDeleteAsync({ e: e, processType: 0, movementId: '', subMethod: 'btn - bankAccountMovementAdd', })}
                                                        tooltip='tooltip'
                                                        title={labels?.add?.[languageObj?.id]}>
                                                        <i id={controls?.icons?.add?.id} className={controls?.icons?.add?.className} /> <span id={controls?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.search?.id}
                                                        className={controls?.buttons?.search?.className}
                                                        disabled={btnDisabled}
                                                        onClick={(e) => bankAccountMovementsGetAsync({ e: e, bankAccount_: bankAccount, subMethod: 'btn - bankAccountMovementsSearch' })}
                                                        tooltip='tooltip'
                                                        title={labels?.search?.[languageObj?.id]}>
                                                        <i id={controls?.icons?.search?.id} className={controls?.icons?.search?.className} /> <span id={controls?.spinners?.search?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.print?.id}
                                                        className={controls?.buttons?.print?.className}
                                                        disabled={btnDisabled}
                                                        onClick={(e) => bankAccountMovementsPrintAsync({ e: e, subMethod: 'btn - reportPrint', })}
                                                        tooltip='tooltip'
                                                        title={labels?.toPrint?.[languageObj?.id]} >
                                                        <i id={controls?.icons?.print?.id} className={controls?.icons?.print?.className} /> <span id={controls?.spinners?.print?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.className}
                                                        onClick={(e) => goToBackAsync(e)}
                                                        tooltip='tooltip'
                                                        title={labels?.back?.[languageObj?.id]}>
                                                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            {/* <div> */}
                                            {/* {showData ? */}
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtBankAccountMovementsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                            {/* : */}
                                            {/* <div></div> */}
                                            {/* } */}
                                            {/* </div> */}
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>
                                    </div>

                                    <div className='card-footer'>
                                        <div className='row'>
                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.primary}><i className={icons?.caretLeft}></i> {
                                                        separatorsNumbersSet({
                                                            number: previousBalance,
                                                            withDecimals: true,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'lbl - previousBalance',
                                                        })?.result
                                                    }</span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.previousBalance?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.success}><i className={icons?.caretUp}></i> {
                                                        separatorsNumbersSet({
                                                            number: incomeAmount,
                                                            withDecimals: true,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'lbl - incomeAmount',
                                                        })?.result
                                                    }</span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.incomes?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block border-right'>
                                                    <span className={descriptionPercentageObj?.danger}><i className={icons?.caretDown}></i> {
                                                        separatorsNumbersSet({
                                                            number: expensesAmount,
                                                            withDecimals: true,
                                                            consoleLogErrorShow: true,
                                                            subMethod: 'lbl - expensesAmount',
                                                        })?.result
                                                    }</span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.egresses?.[languageObj?.id]}</span>
                                                </div>

                                            </div>

                                            <div className='col-sm-3 col-6'>
                                                <div className='description-block'>
                                                    <span className={movementAmount < 0 ? descriptionPercentageObj?.danger : (movementAmount > 0 ? descriptionPercentageObj?.success : descriptionPercentageObj?.primary)}>
                                                        <i className={movementAmount < 0 ? icons?.caretDown : (movementAmount > 0 ? icons?.caretUp : icons?.caretRight)}></i> {
                                                            //separatorsNumbersSet(movementAmount).result
                                                            separatorsNumbersSet({
                                                                number: movementAmount,
                                                                withDecimals: true,
                                                                consoleLogErrorShow: true,
                                                                subMethod: 'lbl - movementAmount',
                                                            })?.result

                                                        }
                                                    </span>
                                                    <h5 className='description-header'>---</h5>
                                                    <span className='description-text'>{labels?.movements?.[languageObj?.id]}</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}

                </section>{/* /.content */}
            </div>

            {bankAccountMovementDetailShowModal ?
                <BankAccountMovementDetails $={$}
                    auth={auth}
                    bankAccountMovement={bankAccountMovement}
                    showModal={bankAccountMovementDetailShowModal}
                    setShowModal={setBankAccountMovementDetailShowModal}
                    languageObj={languageObj} />
                :
                <div></div>
            }

            {bankAccountMovementShowModal ?
                <BankAccountMovementAddEditDetails $={$}
                    auth={auth}
                    bankAccountMovement={bankAccountMovement}
                    setMovement={setBankAccountMovement}
                    processType={processType}
                    btnMovementSearchId={controls?.buttons?.search?.id}
                    showModal={bankAccountMovementShowModal}
                    setShowModal={setBankAccountMovementShowModal}
                    languageObj={languageObj} />
                :
                <div></div>
            }

        </div>
    )
}